import type { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ColorAdvice4, ColorOpacityDark2 } from 'autogen/design-tokens/tokens';
import type { AdvisorToolboxItem } from 'autogen/swagger/all';
import { ClubMatas } from 'autogen/translation-keys/trans-website-advisortoolbox-shared';
import Card from 'components/generic/card';
import { Typography } from 'components/generic/typography';
import { verticalEllipsis } from 'modules/helpers/mixins';
import type { IToolboxTheme } from '../shared/types';

const StyledCard = styled(Card)<{ theme: IToolboxTheme }>`
    position: relative;
    cursor: pointer;
    background-color: ${ColorAdvice4};
`;

const Bottom = styled.div`
    margin-top: auto;
`;

const StyledBody = styled(Typography.Body)`
    margin: 0;
    line-height: 1.5;
`;

const StyledBodyDescription = styled(StyledBody)`
    ${verticalEllipsis(2)}
`;

const StyledBottomText = styled(StyledBody)`
    color: ${ColorOpacityDark2};
`;

const HeadlineContent = styled.div`
    display: flex;
    align-items: center;
`;

export default function ToolboxCard(props: { item: AdvisorToolboxItem } & HTMLAttributes<HTMLDivElement>) {
    const { item, ...rest } = props;
    const { isClubMatasOnly, headline, description } = item;
    const { t } = useTranslation();

    return (
        <StyledCard size="md" {...rest}>
            <Card.Content>
                <HeadlineContent>
                    <StyledBody size="M" strong>
                        {headline}
                    </StyledBody>
                </HeadlineContent>
                <StyledBodyDescription size="M">{description}</StyledBodyDescription>

                <Bottom>{isClubMatasOnly && <StyledBottomText size="M">{t(ClubMatas)}</StyledBottomText>}</Bottom>
            </Card.Content>
        </StyledCard>
    );
}
